import React, { useMemo, useState } from "react";
import { Table } from "antd";
import { ModalBase } from "../../../../../Components/Modais/ModalBase/ModalBase";
import DocumentPreview from "../../../shared/components/DocumentPreview/DocumentPreview";
import { EMPTY_LOGS_LABEL, USER_LOGS_TITLE } from "../../constants";
import { getLogDocument } from "../../utils/logFormatters";
import DetailsCard from "../DetailsCard/DetailsCard";
import { getUserLogsColumns } from "./columns";
import classes from "./UserLogs.module.scss";

const UserLogs = ({ logs, isLoading }) => {
  const [selectedLog, setSelectedLog] = useState(null);

  const logDocument = useMemo(
    () => getLogDocument(selectedLog?.rawLog),
    [selectedLog]
  );

  const columns = useMemo(
    () => getUserLogsColumns({ onViewPayload: setSelectedLog }),
    []
  );

  return (
    <DetailsCard title={USER_LOGS_TITLE}>
      <Table
        columns={columns}
        dataSource={logs}
        loading={isLoading}
        locale={{ emptyText: EMPTY_LOGS_LABEL }}
        pagination={false}
        rowKey="key"
        tableLayout="fixed"
      />

      <ModalBase
        animated={false}
        open={Boolean(selectedLog)}
        onCancel={() => setSelectedLog(null)}
        title={
          <div className={classes.ModalTitle}>
            <span>{selectedLog?.event}</span>
            <span className={classes.ModalDate}>{selectedLog?.date}</span>
          </div>
        }
        titleFontSize="16px"
        width={800}
        footer={null}
      >
        <pre className={classes.PayloadContent}>
          {JSON.stringify(selectedLog?.rawLog, null, 2)}
        </pre>

        {logDocument && (
          <div className={classes.DocumentArea}>
            <DocumentPreview
              document={logDocument.document}
              documentUrl={logDocument.url}
            />
          </div>
        )}
      </ModalBase>
    </DetailsCard>
  );
};

export default UserLogs;
